
export const TARGET_SRC = '/targets/hop_thanh_truc.mind';
export const PRODUCTS = {
  'hop-2-banh': {
    anchorIndex: [0, 1, 2, 3],
    targetSrc: '/targets/hop_thanh_truc.mind',
    anchors: {
      0: { videoSrc: '/videos/Video_Trung_Thu.mp4' },
      1: { videoSrc: '/videos/Video_Trung_Thu.mp4' },
      2: { videoSrc: '/videos/Hop_2_banh.mp4' },
      3: { videoSrc: '/videos/Hop_2_banh.mp4' }
    },
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  },
  'hop-4-banh': {
    anchorIndex: [0, 1],
    targetSrc: '/targets/hop_thanh_truc.mind',
    anchors: {
      0: { videoSrc: '/videos/Video_Trung_Thu.mp4' },
      1: { videoSrc: '/videos/Video_Trung_Thu.mp4' },
    },
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  }
};
